
    import { makeI18n } from '@/services/i18n';
    const baseTranslation = undefined
    
    
    if(module.hot) {
      const bucket = require("/app/build/i18n/browser-bucket.js");
      bucket.add('src/components/vjsf/widgets/form-field-partial-dictionary.vue', {"hint":{"ru_RU":"Добавляют, удаляют и настраивают порядок и вложенность пунктов управляющие рекрутеры","en_US":"Owners can add, remove and change the order and nesting of&nbsp;items in the settings"},"hint.editable":{"ru_RU":"Добавляют, удаляют и настраивают порядок и вложенность пунктов <a>в настройках</a>","en_US":"You can add, remove and change the order and nesting of items <a>in the settings</a>"}}) 
    }
   
    
    export default function (Component) {
      function beforeCreateI18n() {
        this.$i18n = this.$options._i18n;
      }

      function addHook(current) {
        if (Array.isArray(current)) {
          return [beforeCreateI18n].concat(current);
        } 
        if (current) {
          return [beforeCreateI18n, current];
        }
        return [beforeCreateI18n];
      }
    
      Component._i18n = makeI18n("src/components/vjsf/widgets/form-field-partial-dictionary.vue", baseTranslation);
      Component.beforeCreate = addHook(Component.beforeCreate);
      delete Component._Ctor;
    }
  